export const REVIEWS_TOUR_LANDING_API_START = "REVIEWS_TOUR_LANDING_API_START";
export const REVIEWS_TOUR_LANDING_API_SUCCESS = "REVIEWS_TOUR_LANDING_API_SUCCESS";
export const REVIEWS_TOUR_LANDING_API_ERROR = "REVIEWS_TOUR_LANDING_API_ERROR";